import SvgRender from '@/library/components/general/SvgRender';
import { FC, ReactNode } from 'react';
import { clsx } from 'clsx';

import check from '@/library/assets/svg/common/check-circle-solid.svg';
import error from '@/library/assets/svg/common/x-circle.svg';

type DisplayBooleanProps = { isChecked: boolean; className?: string; label?: ReactNode };

const DisplayBoolean: FC<DisplayBooleanProps> = ({ isChecked, label, className = '' }) => {
  return (
    <div
      className={`d-inline-flex align-items-center ${className} ${clsx(
        isChecked && 'text-turquoise'
      )} ${clsx(!isChecked && 'text-violet')}`}
    >
      <SvgRender src={isChecked ? check : error} style={{ width: 16, height: 16 }} />
      {label ? <div className="ps-1 fs-12 fw-medium">{label}</div> : null}
    </div>
  );
};

export default DisplayBoolean;
